export const setCookie = (cAliasModule, cId, cAttribute, cValue, exDays) => {
  let d = new Date();
  d.setTime(d.getTime() + (exDays*24*60*60*1000));//exDays*1000 seconds
  let expires = "expires=" + d.toUTCString();
  document.cookie = cAliasModule + '_' + cId + '_' + cAttribute + "=" + cValue + ";" + expires + ";path=/";
}

export const getCookie = (cAliasModule, cId, cAttribute) => {
  let name = cAliasModule + '_' + cId + '_' + cAttribute + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let keysCookies = decodedCookie.split(';');
    for(let value of keysCookies) {      
      while (value.charAt(0) === ' ') {
        value = value.substring(1);
      }
      if (value.indexOf(name) === 0) {
        return value.substring(name.length, value.length);
      }
    }
    return "";
}

export const checkCookie = (cAliasModule, cId, cAttribute, cValue) => {
    let ck = getCookie(cAliasModule, cId, cAttribute);
    if (ck !== '') {
      return ck;
    }
    setCookie(cAliasModule, cId, cAttribute, cValue);
}